module.exports = __webpack_public_path__ + "static/media/jquery.86e8b271.png";